var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLoadEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92045 11.2507C3.08627 13.963 5.98445 15.8847 9.375 15.8847C13.7932 15.8847 17.375 12.6234 17.375 8.60061M16.8295 5.95051C15.6652 3.23751 12.7663 1.31649 9.375 1.31649C4.95682 1.31649 1.375 4.57779 1.375 8.60061M7.19318 11.2494H1.375V16.5469M17.375 0.654297V5.95184H11.5568",
    stroke: "#047DE7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoadEdit);
export default __webpack_public_path__ + "static/media/IconLoadEdit.6052ef5342878fb215af9276367b8047.svg";
export { ForwardRef as ReactComponent };